import { actionCreatorFactory } from 'typescript-fsa';
import { ApiFieldError } from 'src/types';
import { LoanDocuments } from 'src/types/LoanDocument';

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@manager/loan_documents`);

export const loanDocumentsRequest = actionCreator('request');

export const loanDocumentsRequestSuccess =
  actionCreator<LoanDocuments>('success');

export const loanDocumentsRequestFail = actionCreator<ApiFieldError[]>('fail');
